import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type SendEnvelopeInput = {
  companyName: string;
  companyNumber: string;
  registeredAddress: string;
  signatoryName: string;
  signatoryEmail: string;
  signatoryPosition: string;
  trialEndDate: string;
};

type SendEnvelopeResult = {
  envelopeId: string;
  status: string;
};

export function useSmartCreateEnvelope() {
  const { mutateAsync, isPending } = useMutation<
    { data: SendEnvelopeResult },
    Error,
    SendEnvelopeInput
  >({
    mutationFn: input => api.post<SendEnvelopeResult>('admin/smart-create/send-envelope', input),
  });

  return { sendEnvelope: mutateAsync, isPending };
}
